__turbopack_context__.v({
  "activeThumb": "fullscreen-styles-module__Ol7ibG__activeThumb",
  "closeButton": "fullscreen-styles-module__Ol7ibG__closeButton",
  "emblaContainer": "fullscreen-styles-module__Ol7ibG__emblaContainer",
  "emblaSlide": "fullscreen-styles-module__Ol7ibG__emblaSlide",
  "emblaViewport": "fullscreen-styles-module__Ol7ibG__emblaViewport",
  "fullscreenContent": "fullscreen-styles-module__Ol7ibG__fullscreenContent",
  "fullscreenOverlay": "fullscreen-styles-module__Ol7ibG__fullscreenOverlay",
  "mainCarouselContainer": "fullscreen-styles-module__Ol7ibG__mainCarouselContainer",
  "mainImage": "fullscreen-styles-module__Ol7ibG__mainImage",
  "mainImageContainer": "fullscreen-styles-module__Ol7ibG__mainImageContainer",
  "nextButton": "fullscreen-styles-module__Ol7ibG__nextButton",
  "prevButton": "fullscreen-styles-module__Ol7ibG__prevButton",
  "thumbnailImage": "fullscreen-styles-module__Ol7ibG__thumbnailImage",
  "thumbnailWrapper": "fullscreen-styles-module__Ol7ibG__thumbnailWrapper",
  "thumbnailsContainer": "fullscreen-styles-module__Ol7ibG__thumbnailsContainer",
});
